export const vh = (percent) => {
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    return (percent * h) / 100;
}
  
export const vw = (percent) => {
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return (percent * w) / 100;
}

export const vmin = (percent) => {
    return Math.min(vh(percent), vw(percent));
}

export const isLandscape = () => {
    return window.innerWidth > window.innerHeight;
}

export const isMobileScreenResolution = () => {
    return window.innerWidth <= 1280;
}

export const isFullscreen = () => {
    return !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
    );
}
